import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { FilterMatchMode, SelectItem } from 'primeng/api';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-column-filter',
  templateUrl: './mx.table-column-filter.component.html',
  styleUrls: ['./mx.table-column-filter.component.scss'],
})
export class MxTableColumnFilterComponent extends MxBaseComponent {
  @Input() type: string;
  @Input() field: string;
  @Input() matchMode: FilterMatchMode;
  @Input() useFilterTemplate: boolean;
  @Input() showApplyButton: boolean = true;
  @Input() showClearButton: boolean = true;
  @Input() matchModeOptions: SelectItem[];

  @ContentChild('filterTemplateRef', { static: false })
  filterTemplateRef: TemplateRef<any>;
}
